enum FieldType {
    Global,
    Titles,
    IndicativePrice,
    ReviewSnippets,
    Description,
    UrgencyMessaging,
    Url,
    Summary,
    Characteristics,
    Distances,
    Facilities,
    Destinations,
    EstabGroupIds,
    RoomNightsBooked,
    LegacyFacilities,
    RoomDetails,
    Pricing,
    RoomAvailability,
    HolidayDeals,
    Airports,
    Weather,
    Recommendations,
    TransferTimes,
    UserClicks,
    UserBookings,
    AltTitles,
    HotelDeals,
    HotelAwards
};

export function getFieldGroup(...args: FieldType[]) {
    return _.flattenDeep(args)
        .reduce((fPrev, fCurrent) => fPrev + (FieldType[fCurrent] ? 1 << fCurrent : 0), 0);
}

export function getFieldTypes() {
    return FieldType;
}
